import { axios, createFormData, handleError } from '../axios';

export const memberRegister = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/account/register', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
